import dtos from '@/dtos/course';
import { DEFAULT_DRAFT } from './state';
import storage from './storage';
import {
    FETCH_PROGRAMS,
    POST_COURSE,
    PATCH_COURSE,
    PATCH_CURRENT_COURSE,
    DELETE_CURRENT_COURSE,
    DELETE_REMAINING_COURSES,
    DELETE_COURSE,
    NOTIFY_COURSE,
    FETCH_COURSE,
    FETCH_STATS,
    FETCH_MULTI_STATS,
    COURSE_DRAFT_INITIALIZE,
    COURSE_DRAFT_FILL,
    COURSE_USED_TRAINERS_FILL,
    CLOSE_COURSE,
} from './types';

export default {
    [FETCH_PROGRAMS](state, payload) {
        state.programs = payload;
    },
    [FETCH_COURSE](state, payload) {
        state.course = dtos.course(payload);
    },
    [POST_COURSE](state, payload) {
        state.created = payload.map(c => dtos.course(c));
    },
    [PATCH_COURSE](state, payload) {
        state.patched = payload.map(c => dtos.course(c));
    },
    [PATCH_CURRENT_COURSE](state, payload) {
        state.patched = dtos.course(payload);
    },
    [DELETE_CURRENT_COURSE](state, payload) {
        state.deleted = dtos.course(payload);
    },
    [DELETE_REMAINING_COURSES](state, payload) {
        state.deleted = payload.map(c => dtos.course(c));
    },
    [DELETE_COURSE](state, payload) {
        state.deleted = dtos.course(payload);
    },
    [NOTIFY_COURSE](state, payload) {
        state.patched = dtos.course(payload);
    },
    [CLOSE_COURSE](state, payload) {
        state.patched = dtos.course(payload);
    },
    [FETCH_STATS](state, payload) {
        state.stats = {
            ...state.stats,
            [payload.date]: payload.stats,
        };
    },
    [FETCH_MULTI_STATS](state, payload) {
        state.stats = {
            ...state.stats,
            ...payload,
        };
    },
    [COURSE_DRAFT_INITIALIZE](state) {
        state.draft = { ...DEFAULT_DRAFT };
        storage.setDraft(state.draft);
    },
    [COURSE_DRAFT_FILL](state, payload) {
        state.draft = { ...state.draft, ...payload };
        if (state.draft.id > 0) {
            storage.removeDraft();
        } else {
            storage.setDraft(state.draft);
        }
    },
    [COURSE_USED_TRAINERS_FILL](state, payload) {
        const existsIdx = state.used_trainers.indexOf(payload.id);
        if (existsIdx >= 0) {
            state.used_trainers.splice(existsIdx, 1);
        }
        state.used_trainers.unshift(payload.id);
        storage.setUsedTrainers(state.used_trainers);
    },
};



// WEBPACK FOOTER //
// ./src/store/course/mutations.js